module.exports = __webpack_public_path__ + "img/highlighting-purple.f6daa46d.svg";